import Api from './'

const casts = {

	/**
	 * Get a list of casts.
	 */
	list(params={})
	{
		let url = Api.getUrl(`casts`)

		return Api.client().get(url, { params })
	},

	/**
	 * Get one cast details.
	 */
	one(slug, params={})
	{
		let url = Api.getUrl(`cast/${slug}`)

		return Api.client().get(url, { params })
	},

}

export default casts